let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class TemplatesService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
  }
  
  deleteCartTemplate(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.deleteCartTemplate,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getUserCartTemplates(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getUserCartTemplates,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  duplicateCartTemplate(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.duplicateCartTemplate,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  duplicateCartTemplateWithStock(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.duplicateCartTemplateWithStock,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then((response) => {
        if (!response.data.error) {
            resolve(response.data);
        } else {
            reject(response.data.message);
        }
      }).catch(reason => {
          reject(reason);
      });
    });
  }


}

TemplatesService.$inject = inject;

export default TemplatesService;



/** WEBPACK FOOTER **
 ** ./www/components/templates/templates.service.js
 **/